export default function getSessionControlTypeName(controlTypeId) {
    switch (controlTypeId) {
        case 0: return 'Экзамен';
        case 1: return 'Зачёт';
        case 2: return 'Дифф. зачёт';
        case 3: return 'Курсовая работа';
        case 4: return 'Курсовой проект';
        default: return '';
    }
}